import React, { useMemo } from 'react'
import { ArrowRight, Users } from 'lucide-react'
import { Button } from '../../components/ui'
import { resolveGroupSize, resolveTeamsAdvancing, tablesFor } from '../tournamentStandings'
import { StandingsTable, fmtDate } from './shared'

function OverviewTab({ tournament, onGoTab }) {
  const tables = useMemo(() => tablesFor(tournament), [tournament])
  const isGroups = tournament.format === 'GROUPS_THEN_KNOCKOUT'
  const advancing = isGroups ? resolveTeamsAdvancing(tournament) : 0

  const details = [
    { k: 'Sted', v: tournament.locationName || '—' },
    { k: 'Synlighet', v: tournament.visibility === 'PUBLIC' ? 'Offentlig' : 'Privat' },
    { k: 'Lagtype', v: tournament.teamSource === 'SQUADS' ? 'Squads' : 'Egne lag' },
    { k: 'Spillere/lag', v: tournament.maxPlayersPerTeam, mono: true }
  ]
  if (isGroups) {
    details.push(
      { k: 'Lag per gruppe', v: resolveGroupSize(tournament), mono: true },
      { k: 'Videre per gruppe', v: resolveTeamsAdvancing(tournament), mono: true }
    )
  }
  details.push(
    { k: 'Starter', v: fmtDate(tournament.startsAt), mono: true },
    { k: 'Slutter', v: fmtDate(tournament.endsAt), mono: true },
    {
      k: 'Arrangør',
      v: tournament.organizerFacilityName || tournament.organizerGroupName || tournament.creatorName
    },
    { k: 'Opprettet av', v: tournament.creatorName }
  )

  return (
    <div className="tn-overview-grid">
      <section className="card tn-card" aria-labelledby="tn-det-h">
        <h2 id="tn-det-h" className="section-title">Detaljer</h2>
        {tournament.imageUrl && (
          <img src={tournament.imageUrl} alt="" className="tn-cover" />
        )}
        <div className="stack-sm">
          <span className="eyebrow">Beskrivelse</span>
          <p className="tn-description">{tournament.description || '—'}</p>
        </div>
        <dl className="tn-dl">
          {details.map((d) => (
            <div key={d.k}>
              <dt>{d.k}</dt>
              <dd className={d.mono ? 'mono' : undefined}>{d.v}</dd>
            </div>
          ))}
        </dl>
      </section>

      <div className="stack">
        <section className="card tn-card" aria-labelledby="tn-quick-h">
          <h2 id="tn-quick-h" className="section-title">Hurtigoversikt</h2>
          <div className="tn-quick-grid">
            <button type="button" className="tn-quick-tile" onClick={() => onGoTab('lag')}>
              <span className="tn-quick-label">Lag</span>
              <span className="tn-quick-value">{tournament.teamCount}</span>
            </button>
            <button type="button" className="tn-quick-tile" onClick={() => onGoTab('kamper')}>
              <span className="tn-quick-label">Kamper</span>
              <span className="tn-quick-value">{tournament.matchCount}</span>
            </button>
            <button type="button" className="tn-quick-tile" onClick={() => onGoTab('admins')}>
              <span className="tn-quick-label">Admins</span>
              <span className="tn-quick-value">{(tournament.admins || []).length}</span>
            </button>
          </div>
          {tournament.inviteCode && tournament.teamSource === 'SQUADS' && (
            <div className="tn-hint-lime">
              <Users size={20} strokeWidth={1.9} aria-hidden="true" />
              <span>
                Del invitasjonskoden <b className="tn-code-inline">{tournament.inviteCode}</b> så squads kan melde seg på.
              </span>
            </div>
          )}
          <Button block onClick={() => onGoTab('oppsett')}>
            Åpne oppsett
            <ArrowRight size={18} strokeWidth={1.9} aria-hidden="true" />
          </Button>
        </section>

        {tables.length > 0 && (
          <section className="card tn-card" aria-labelledby="tn-table-h">
            <div className="tn-head-row">
              <h2 id="tn-table-h" className="section-title">Tabell</h2>
              <button type="button" className="link-btn" onClick={() => onGoTab('oppsett')}>
                {tables.length > 2 ? 'Alle grupper' : 'Se oppsett'}
              </button>
            </div>
            {tables.slice(0, 2).map((t) => (
              <StandingsTable
                key={t.groupNumber}
                title={t.title}
                rows={t.rows}
                compact
                advancing={advancing}
              />
            ))}
            {isGroups && (
              <span className="tn-footnote">Grønn plassering går videre til sluttspill.</span>
            )}
          </section>
        )}
      </div>
    </div>
  )
}

export default OverviewTab
